/**
 * Multiplayer Store — tracks WebSocket connection state for
 * cross-sim multiplayer (GraphicsSIM observing SwitcherSIM room).
 */

import { createStore } from 'zustand/vanilla';

export interface MultiplayerStoreState {
  isConnected: boolean;
  roomCode: string | null;
  playerToken: string | null;
  currentProgramInput: number;
  liveCameraUrl: string | null;
  videoUrls: Record<number, string>;  // input → url map from room state

  // Actions
  setConnected: (connected: boolean) => void;
  setRoomCode: (code: string | null) => void;
  setPlayerToken: (token: string | null) => void;
  setLiveCameraInput: (input: number, url?: string) => void;
  setVideoUrls: (urls: Record<number, string>) => void;
  reset: () => void;
}

export const multiplayerStore = createStore<MultiplayerStoreState>((set, get) => ({
  isConnected: false,
  roomCode: null,
  playerToken: null,
  currentProgramInput: 1,
  liveCameraUrl: null,
  videoUrls: {},

  setConnected: (isConnected) => set({ isConnected }),

  setRoomCode: (roomCode) => set({ roomCode }),

  setPlayerToken: (playerToken) => set({ playerToken }),

  setLiveCameraInput: (input, url) => {
    const urls = get().videoUrls;
    const liveCameraUrl = url ?? urls[input] ?? null;
    set({ currentProgramInput: input, liveCameraUrl });
  },

  setVideoUrls: (videoUrls) => set({ videoUrls }),

  reset: () => set({
    isConnected: false,
    roomCode: null,
    playerToken: null,
    currentProgramInput: 1,
    liveCameraUrl: null,
    videoUrls: {},
  }),
}));
